import { Component, OnInit, Input } from '@angular/core';
import { PortalEndCustomer } from '../../_models/portal/interfaces';

interface CustomerField {
  field: keyof PortalEndCustomer;
  header: string;
  type: 'text' | 'date' | 'string' | 'number' | 'currency' | 'status';
}

@Component({
  selector: 'share-customer-details',
  templateUrl: './share-user-customer-details.component.html',
  styleUrls: ['./share-user-customer-details.component.scss']
})
export class ShareUserCustomerDetailsComponent implements OnInit {
  customerFieldsToDisplay: CustomerField[] = [
    { field: 'first_name', header: 'Name', type: 'text' },
    { field: 'last_name', header: 'Surname', type: 'text' },
    { field: 'mobile_number', header: 'Mobile Number', type: 'text' },
    { field: 'email', header: 'Email', type: 'text' },
    { field: 'identification_reference', header: 'ID Reference', type: 'text' },
    { field: 'alternate_contact_number', header: 'Alternate Contact Number', type: 'text' }
  ];

  @Input() customer: PortalEndCustomer | undefined;

  constructor() {}

  ngOnInit(): void {}

  // mobile_number and contact_number are two independent flat columns on
  // the same customer record (not kept in sync with each other, and
  // unrelated to the separate contact_items system) - some records only
  // ever had contact_number populated (e.g. imports/signups that predate
  // mobile_number being the primary field), so "Mobile Number" falls back
  // to it rather than showing blank when a real number is on file.
  getFieldValue(field: keyof PortalEndCustomer): unknown {
    if (field === 'mobile_number') {
      return this.customer?.mobile_number || this.customer?.contact_number;
    }
    return this.customer?.[field];
  }
}
